
<template>
  <div>
    <img src="https://coderthemes.com/hyper/saas/assets/images/mail_sent.svg" width="80"  alt="">
    <h1 class="mt-3 mb-0">Success !</h1>
    <p> {{message}}</p>
    <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver2">
      <div v-if="error_message"  role="alert" aria-live="polite" aria-atomic="true" class="alert bg-white alert-danger">
    <div class="iq-alert-icon"><i class="ri-information-line"></i></div>
    <div class="iq-alert-text"> <b>{{ error_message }}</b></div>
  </div>
      <form @submit.prevent="handleSubmit(validateEmail)" ref="form2">
      <ValidationProvider vid="code" name="Code" :rules="rules.code" v-slot="{ errors }">
    <div class="form-group">
      <VuePincodeInput
      v-model="validateCode.code"
      :length="6"
      type="numeric"
      focus
    />
    </div>
    <div class="invalid-feedback">
          <span>{{ errors[0] }}</span>
        </div>
  </ValidationProvider>
   
    <div class="d-inline-block w-100">
      <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
      <button v-else type="submit" class="btn btn-primary float-right">submit</button>
    </div>
  </form>
</ValidationObserver>
  </div>
</template>
<script>
import VuePincodeInput from "vue-pincode-input";
import { resetpassword } from "@/API/UsersAPIs";
import { setAccessToken } from "@/Utils/authentication";
import { getAccessToken } from "../../../Utils/authentication";
import { core } from '@/config/pluginInit';
export default {
  name: 'ConfirmMail1',
  components: {
    VuePincodeInput,
  },
  data() {
    return {
      loading: false,
    error_message:'',
      validateCode: {
      code: '',
    },
    rules: {
      code: 'required|min:6'
    },
    }
},
computed: {
  
    message() {
      return this.$store.state.User.forgotpasswordStep1.message;
    },
  },
  mounted() {
    core.index();
    const data = JSON.parse(JSON.stringify(this.$store.state.User.forgotpasswordStep1))
    if (data && data.email) {
    this.validateCode.email = data.email; 
  }
  if (data && data.phone) {
    this.validateCode.phone = data.phone; 
  }
    if(!data.email && !data.phone){
      this.$router.push('/auth/sign-in1');
    }
  },
methods: {
  async validateEmail() {
    this.loading = true;
      try {
        const user = await resetpassword(this.validateCode)
        if (user.token) {
        setAccessToken(user.token)
        if(getAccessToken()){
          this.$router.push('/auth/write-new-password');
        }
      }
      this.$store.commit('User/setForgotpasswordStep1', {
        userID: user.id,
      });
       this.error_message="";
       this.loading = false;
      }
      catch(error) {
        this.error_message = error.message === "Network Error"
          ? error.message
          :error.response.data['message']         
        }finally{ this.loading = false}
  },
},
}
</script>
